import { API_URL, API_TOKEN } from "../api/apiConfig";

export const fetchHomelocalexpertList = async () => {
  try {
    const response = await fetch(`${API_URL}/localexpert_list`, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
    });

    return await response.json();
  } catch (error) {
    console.log("Localexpert API Error:", error);
    return null;
  }
};
